module.exports = __webpack_public_path__ + "img/answer-call.b24c2405.png";